import { render } from "./Verify.vue?vue&type=template&id=872d7aea"
import script from "./Verify.vue?vue&type=script&lang=js"
export * from "./Verify.vue?vue&type=script&lang=js"

import "./Verify.vue?vue&type=style&index=0&id=872d7aea&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/verifition/Verify.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "872d7aea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('872d7aea', __exports__)) {
    api.reload('872d7aea', __exports__)
  }
  
  module.hot.accept("./Verify.vue?vue&type=template&id=872d7aea", () => {
    api.rerender('872d7aea', render)
  })

}


export default __exports__